import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/image/newhome/title.png'
import _imports_1 from '../../../assets/image/newhome/1/logo.png'
import _imports_2 from '../../../assets/image/newhome/1/jiqiren-bai.png'
import _imports_3 from '../../../assets/image/newhome/1/jiqiren-zi.png'
import _imports_4 from '../../../assets/image/newhome/1/kongzhigui-bai.png'
import _imports_5 from '../../../assets/image/newhome/1/kongzhigui-zi.png'
import _imports_6 from '../../../assets/image/newhome/1/moduan-bai.png'
import _imports_7 from '../../../assets/image/newhome/1/moduan-zi.png'
import _imports_8 from '../../../assets/image/newhome/1/shijue-bai.png'
import _imports_9 from '../../../assets/image/newhome/1/shijue-zi.png'
import _imports_10 from '../../../assets/image/newhome/1/shusong-bai.png'
import _imports_11 from '../../../assets/image/newhome/1/shusong-zi.png'
import _imports_12 from '../../../assets/image/newhome/1/cardright-bai.png'
import _imports_13 from '../../../assets/image/newhome/1/cardright-zi.png'
import _imports_14 from '../../../assets/image/newhome/1/zidonghua-bai.png'
import _imports_15 from '../../../assets/image/newhome/1/zidonghua-zi.png'
import _imports_16 from '../../../assets/image/newhome/light.png'
import _imports_17 from '../../../assets/image/newhome/1/good.png'
import _imports_18 from '../../../assets/image/newhome/1/xiangzi.png'
import _imports_19 from '../../../assets/image/newhome/indicate.png'
import _imports_20 from '../../../assets/image/newhome/recommend2.png'
import _imports_21 from '../../../assets/image/newhome/recommend.png'
import _imports_22 from '../../../assets/image/newhome/jiantou.png'
import _imports_23 from '@/assets/icon/3d.png'


const _withScopeId = n => (_pushScopeId("data-v-5329bbf0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scheme" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"title\" data-v-5329bbf0><img src=\"" + _imports_0 + "\" alt=\"\" data-v-5329bbf0><div class=\"text\" data-v-5329bbf0>自动化设计方案</div><img src=\"" + _imports_0 + "\" alt=\"\" data-v-5329bbf0></div><div class=\"title1\" data-v-5329bbf0>真实方案 即下即用</div>", 2)
const _hoisted_4 = { class: "scheme-img container" }
const _hoisted_5 = { class: "left" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "logo"
}, null, -1))
const _hoisted_7 = {
  src: _imports_13,
  alt: "",
  class: "cardright"
}
const _hoisted_8 = {
  src: _imports_15,
  alt: "",
  class: "zidonghua"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_17,
  alt: "",
  class: "good"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_18,
  alt: "",
  class: "xiangzi"
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_19,
  alt: ""
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "right-title" }, "工业自动化设计方案共享平台"),
  /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
    /*#__PURE__*/_createTextVNode(" 我们将自动化、机器人领域经过多年迭代、运用的成熟设计资料，通过精细的整合、分类、标准化后以资料包的形式呈现于平台之上，供设计者、爱好者、学习者下载使用或学习参考。资料内容齐全、完整，包含最为详尽的"),
    /*#__PURE__*/_createElementVNode("span", null, "设计建模、加工图纸、BOM、应用指导、演示视频"),
    /*#__PURE__*/_createTextVNode("等，保证每一个文件的可信、可靠、即下即用。 ")
  ])
], -1))
const _hoisted_13 = { class: "good-title container" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 0,
  src: _imports_20,
  alt: "",
  class: "recommend"
}
const _hoisted_16 = {
  key: 1,
  src: _imports_21,
  alt: "",
  class: "recommend"
}
const _hoisted_17 = { class: "p" }
const _hoisted_18 = {
  key: 2,
  src: _imports_22,
  alt: "",
  class: "jiantou"
}
const _hoisted_19 = { class: "good-list container" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "pic" }
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "pic-img-3d",
  src: _imports_23
}, null, -1))
const _hoisted_24 = { class: "txt" }
const _hoisted_25 = { class: "title-two nowrap" }
const _hoisted_26 = { class: "attr nowrap" }
const _hoisted_27 = { class: "price" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-a-Group14379" }, null, -1))
const _hoisted_29 = { class: "click-num" }
const _hoisted_30 = { class: "left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _withDirectives(_createElementVNode("img", {
          src: _imports_2,
          alt: "",
          class: "jiqiren",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.active(4)))
        }, null, 512), [
          [_vShow, _ctx.isActive != 4]
        ]),
        _withDirectives(_createElementVNode("img", {
          src: _imports_3,
          alt: "",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.active(4))),
          class: "jiqiren"
        }, null, 512), [
          [_vShow, _ctx.isActive == 4 || _ctx.isActive == 3]
        ]),
        _withDirectives(_createElementVNode("img", {
          src: _imports_4,
          alt: "",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.active(5))),
          class: "kongzhigui"
        }, null, 512), [
          [_vShow, _ctx.isActive != 5]
        ]),
        _withDirectives(_createElementVNode("img", {
          src: _imports_5,
          alt: "",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.active(5))),
          class: "kongzhigui"
        }, null, 512), [
          [_vShow, _ctx.isActive == 5 || _ctx.isActive == 3]
        ]),
        _withDirectives(_createElementVNode("img", {
          src: _imports_6,
          alt: "",
          class: "moduan",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.active(1)))
        }, null, 512), [
          [_vShow, _ctx.isActive != 1]
        ]),
        _withDirectives(_createElementVNode("img", {
          src: _imports_7,
          alt: "",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.active(1))),
          class: "moduan"
        }, null, 512), [
          [_vShow, _ctx.isActive == 1 || _ctx.isActive == 3]
        ]),
        _withDirectives(_createElementVNode("img", {
          src: _imports_8,
          alt: "",
          class: "shijue",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.active(6)))
        }, null, 512), [
          [_vShow, _ctx.isActive != 6]
        ]),
        _withDirectives(_createElementVNode("img", {
          src: _imports_9,
          alt: "",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.active(6))),
          class: "shijue"
        }, null, 512), [
          [_vShow, _ctx.isActive == 6 || _ctx.isActive == 3]
        ]),
        _withDirectives(_createElementVNode("img", {
          src: _imports_10,
          alt: "",
          class: "shusong",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.active(2)))
        }, null, 512), [
          [_vShow, _ctx.isActive != 2]
        ]),
        _withDirectives(_createElementVNode("img", {
          src: _imports_11,
          alt: "",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.active(2))),
          class: "shusong"
        }, null, 512), [
          [_vShow, _ctx.isActive == 2 || _ctx.isActive == 3]
        ]),
        _withDirectives(_createElementVNode("img", {
          src: _imports_12,
          alt: "",
          class: "cardright",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.active(3)))
        }, null, 512), [
          [_vShow, _ctx.isActive != 3]
        ]),
        _withDirectives(_createElementVNode("img", _hoisted_7, null, 512), [
          [_vShow, _ctx.isActive == 3]
        ]),
        _withDirectives(_createElementVNode("img", {
          src: _imports_14,
          alt: "",
          class: "zidonghua",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.active(3)))
        }, null, 512), [
          [_vShow, _ctx.isActive != 3]
        ]),
        _withDirectives(_createElementVNode("img", _hoisted_8, null, 512), [
          [_vShow, _ctx.isActive == 3]
        ]),
        _createElementVNode("img", {
          src: _imports_16,
          alt: "",
          class: "light1 light",
          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.active(4)))
        }),
        _createElementVNode("img", {
          src: _imports_16,
          alt: "",
          class: "light2 light",
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.active(6)))
        }),
        _createElementVNode("img", {
          src: _imports_16,
          alt: "",
          class: "light3 light",
          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.active(1)))
        }),
        _createElementVNode("img", {
          src: _imports_16,
          alt: "",
          class: "light4 light",
          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.active(3)))
        }),
        _createElementVNode("img", {
          src: _imports_16,
          alt: "",
          class: "light5 light",
          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.active(5)))
        }),
        _createElementVNode("img", {
          src: _imports_16,
          alt: "",
          class: "light6 light",
          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.active(2)))
        }),
        _hoisted_9,
        _hoisted_10,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.indicator, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "indicator"
          }, [
            (_ctx.isActive - 1 == index)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  style: _normalizeStyle({ position: 'absolute', left: item.left, top: item.top })
                }, [
                  _hoisted_11,
                  _createElementVNode("p", null, _toDisplayString(item.name), 1)
                ], 4))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      _hoisted_12
    ]),
    _createElementVNode("div", _hoisted_13, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.title, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["title-item", { active: _ctx.isActive == index }]),
          key: index,
          onClick: ($event: any) => (_ctx.active(index))
        }, [
          (index == 0 && _ctx.isActive == 0)
            ? (_openBlock(), _createElementBlock("img", _hoisted_15))
            : _createCommentVNode("", true),
          (_ctx.isActive != 0 && index == 0)
            ? (_openBlock(), _createElementBlock("img", _hoisted_16))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_17, _toDisplayString(item.name), 1),
          (index == _ctx.isActive)
            ? (_openBlock(), _createElementBlock("img", _hoisted_18))
            : _createCommentVNode("", true)
        ], 10, _hoisted_14))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_19, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.goodslit.datas.data, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "goods-info",
          key: index,
          onClick: ($event: any) => (_ctx.goGoods(item.id))
        }, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("img", {
              class: "pic-img",
              src: _ctx.changeUrl(item.photo)
            }, null, 8, _hoisted_22),
            _hoisted_23
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, _toDisplayString(item.names), 1),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("span", null, _toDisplayString(item.attr), 1)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createTextVNode(_toDisplayString(_ctx.showPrice(item.price, 0)), 1)
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, _toDisplayString(item.click) + "次浏览", 1)
            ])
          ])
        ], 8, _hoisted_20))
      }), 128)),
      _createElementVNode("div", {
        class: "more",
        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.goClass()))
      }, "查看更多")
    ])
  ]))
}